import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { CurrentUser } from '../models/currentuser.models';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })

/**
 * Pestamp-service Component
 */
export class PestampService {

  firbasebasecollname: string = 'vendors';
  currentuser!: CurrentUser;
  firebaseclientcollname: string = 'clients';

  constructor(private http: HttpClient, private tokenService: TokenStorageService) {
    this.currentuser = this.tokenService.getCurrentUser();
  }

  /**
   * ADD PESTAMP RECORD API
   */
  addPestampsData(postdata: any) : Observable<any>{
    return this.http.post<any>(BASE_URL + GlobalComponent.pestampsGet, postdata);
  }

  /**
   * GET PESTAMP RECORD API
   * fetch record on basis of record guid
   */
  getPestampsRecordData(recordguid: string) : Observable<any> {
    console.log("fetching pestamp data");
    return this.http.get<any>(BASE_URL + 'pestamp/details/' + recordguid);
  }

  /**
   * UPDATE PESTAMP STATUS
   */
  updatePestampStatus(recordguid: string, postdata: any) : Observable<any>{
    return this.http.put<any>(BASE_URL + 'pestamp/update/' + recordguid,  {data: postdata});
  }

  /**
   * GET PESTAMP MEMBERS LIST
   */
  getPestampsMembersList(recordguid: string) : Observable<any[]> {
    console.log("fetching pestamp members list");
    return this.http.get<any[]>(BASE_URL + 'pestamp/memberlist/' + recordguid);
  }

  /**
   * CANCEL PESTAMP PROJECT
   */
  cancelPestampProject(postdata: any) : Observable<any>{
    return this.http.post<any>(BASE_URL + 'pestampcancels', {data: postdata});
  }

  /**
   * GET PESTAMP ATTACHMENTS
   */
  getPestampsAttachments(recordguid: string) : Observable<any[]> {
    console.log("fetching pestamp attachments list");
    return this.http.get<any[]>(BASE_URL + 'pestampattachments/attachments/'+recordguid);
  }

   /**
   * UPDATE PESTAMP RECORD API
   */
   editPestampsData(postdata: any, recordId: number) : Observable<any>{
    return this.http.put<any>(BASE_URL + GlobalComponent.pestampsGet + '/' + recordId, postdata);
  }

  /**
   * RELEASE RECORD
   */
  releaserecord(jobguid: string, postdata: any) {
    return this.http.put<any>(BASE_URL + 'pestamp/releaserecord/' + jobguid, {data: postdata});
  }

   /**
   * GET PESTAMP FILE ATTACHMENT TO DOWNLOAD FILE
   */
  getPestampFile(recordguid: string) : Observable<any[]> {
    return this.http.get<any[]>(BASE_URL + 'pestampattachments?filters[activestate][$eq]=true&filters[fieldname][$eq]=stampedfile&filters[jobguid][$eq]='+recordguid+'&populate=*');
  }

  /**
   * DELETE LATEST REVISION
   */
  deleterevision(id: number) {
    return this.http.put<any>(BASE_URL + 'pestamprevisionjobs/' + id, { data: { activestate: false }});
  }

}